import { ArcadeThemeColorsOverride } from './arcadeColors'
import { ThemeColorsOverride } from './colors'
import { monochromeArcadeColors, monochromeMooncakeColors } from './monochromeColors'

/**
 * Once monochrome is enabled in Afterpay checkout this theme can replace `cashAfterpayColors`
 */

export const cashAfterpayMonochromeArcadeColors: Partial<ArcadeThemeColorsOverride> = {
  ...monochromeArcadeColors,
}

export const cashAfterpayMonochromeMooncakeColors = {
  ...monochromeMooncakeColors,
} as ThemeColorsOverride
